import React, { useEffect, useState } from "react";
// import EventSignUpInline from "../Home/EventSignUp/EventSignUpInline";
import EventExcerpt from "./EventExcerpt";
import fysee25Logo from "../../Common/_assets/img/fysee25/fysee25logo.png";
// import spinner from "../../Common/_assets/img/placeholder/spinner.gif";
import { listEvents } from "../../utils/api/helpers/event";

const EventList = () => {
	const [eventList, setEventList] = useState(null);
	const [loaded, setLoaded] = useState(null);

	useEffect(() => {
		let subscribed = true;
		if (subscribed && !loaded) {
			setTimeout(() => {
				setLoaded(true);
			}, 1000);

			listEvents().then((result) => {
				// console.log("listEvents", result);
				if (result.data) {
					setEventList(result.data);
				}
			});
		}
		return () => (subscribed = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loaded]);

	return (
		<>
			<div
				className=" events-container width_ctrl nf-sans-cond pt-0 pt-md-5 mb-5 pb-3"
				style={{ marginTop: 75, overflow: "hidden" }}
			>
				<div className="events__grid ">
					<div
						className={"events-grid"}
						style={{ opacity: loaded ? 1 : 0 }}
					>
						<div className={"events-grid-header"}>
							<div>
								<img
									src={fysee25Logo}
									className={"fysee25logo"}
									alt={"FYSEE"}
								/>
							</div>
							<div className={"events-grid-tagline"}>
								The shows you love
								<br />
								In the city you love
							</div>
						</div>

						{eventList ? (
							eventList.map((o, i) => {
								return (
									<EventExcerpt
										key={i}
										i={i}
										event_object={o}
									/>
								);
							})
						) : (
							<></>
						)}
					</div>
				</div>
			</div>
			<div className="events__background" />
			<div className="events__background-gradient" />
		</>
	);
};

export default EventList;
